import bookingsService from "../../common/services/bookingsService";
import { getTimeObjWithOffset } from "@/modules/common/services/timeService";
import moment from "moment";

export default async (serviceUid, startDate, selectedStaff, meetingType = 'appointment') => {
  const staffId = selectedStaff.uid;
  
  const currDate = new Date(startDate);
  const currDateMonth = currDate.getMonth() + 1;
  // let nextDayDate = new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate() + 1);
  // const nextDayMonth = nextDayDate.getMonth() + 1;
  let startDateString = `${currDate.getFullYear()}-${currDateMonth.toString().padStart(2, '0')}-${currDate.getDate()}`;
  // let endDateString = `${nextDayDate.getFullYear()}-${nextDayMonth.toString().padStart(2, '0')}-${nextDayDate.getDate()}`;
  const staffIds = [selectedStaff.uid];

  const type = meetingType === 'appointment' ? 'AppointmentService' : 'EventService';
  const availabilities = await bookingsService.getAvailability(serviceUid, startDateString, startDateString, selectedStaff.time_zone_name, staffIds, null, 'staff', type);
  
  // @TODO - in the future we can extend this to support more than one staff
  // bookingService return availabilities by staffUid - availabilities[staffUid] = [availability1, availability2, ...]
  // _.forEach(availabilities, (staffAvailability, staffId) => do this code
  const requestedDate = new Date(startDateString);
  const staffAvailabilities = {};
  //filter for the requested day
  staffAvailabilities[staffId] = _.flatMap(availabilities, (dateObj, date) => {
      return new Date(date).getTime() === requestedDate.getTime() ? dateObj : [];
    }
  );

  if (Object.keys(staffAvailabilities).length === 0) {
    return [];
  }

  // @TODO - also here we can extend to support more than one staff
  // by going over the availabilites per staff
  // _.forEach(staffAvailabilities, (availabilities, staffId) => {
  const parsedAvailabilities = [];
  // set the start & end time for each staffAvailabilities
  if (!staffAvailabilities[staffId].length) {
    parsedAvailabilities[staffId] = [];
  } else {
    const staffAvailable = staffAvailabilities[staffId];
    _.forEach(staffAvailable, availability => {
      const date = new Date(availability.start_time);
      const staffOffset = moment.tz(date, selectedStaff.time_zone_name).utcOffset();
      const startTime = getTimeObjWithOffset(date, staffOffset);
      const endTime = new Date(startTime);
      endTime.setMinutes(endTime.getMinutes() + availability.duration_minutes);
      if (!parsedAvailabilities[staffId]) {
        parsedAvailabilities[staffId] = [];
      }
      const relatedTimeCheck = parsedAvailabilities[staffId].find(timeSlot => timeSlot.endTime.getTime() === startTime.getTime());
      if (relatedTimeCheck) {
        relatedTimeCheck.endTime = endTime;
      } else {
        parsedAvailabilities[staffId].push({
          startTime,
          endTime
        });
      }
    });
  }

  console.log('parsedAvailabilities', parsedAvailabilities);
  return parsedAvailabilities;
};
